import React from 'react'

import ConnectedField from './ConnectedField'
import UnconnectedField from './UnconnectedField'
import { withForm } from '../context'

export function Field({ form, ...rest }) {
	return form
		? <ConnectedField form={form} {...rest} />
		: <UnconnectedField {...rest} />
}

export default withForm(Field)
